"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _AppBar = _interopRequireDefault(require("../../components/AppBar"));
var _SiteToolbar = _interopRequireDefault(require("../../components/SiteToolbar"));
var _Banner = _interopRequireDefault(require("../Banner"));
var _BannerLinks = _interopRequireDefault(require("../Banner/BannerLinks"));
var _createMemberNavItems = _interopRequireDefault(require("./create-member-nav-items"));
var _HeaderModule = _interopRequireDefault(require("./Header.module.css"));
var _HeaderListItems = _interopRequireDefault(require("./HeaderListItems"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const NAV_ITEM_OFFSET = 3;
const Header = _ref => {
  let {
    children,
    memberNavItems,
    relatedNavItems,
    siteNavItems,
    subtitle
  } = _ref;
  const [openMenu, setOpenMenu] = (0, _react.useState)(false);
  const user = (0, _reactRedux.useSelector)(state => state.user);
  const location = (0, _reactRouterDom.useLocation)();
  const completeMemberNavItems = [...memberNavItems, ...(0, _createMemberNavItems.default)(user, location.pathname)];
  const toggleDrawer = open => () => setOpenMenu(open);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AppBar.default, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "grid",
    gridTemplateColumns: "auto max-content",
    gridTemplateRows: "auto min-content"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_Banner.default, {
    subtitle: subtitle
  }, children)), /*#__PURE__*/_react.default.createElement(_material.Hidden, {
    mdDown: true
  }, /*#__PURE__*/_react.default.createElement(_BannerLinks.default, {
    listItemProps: {
      disablePadding: true
    },
    items: relatedNavItems
  }), /*#__PURE__*/_react.default.createElement(_SiteToolbar.default, {
    disableGutters: true,
    sx: {
      ml: NAV_ITEM_OFFSET,
      justifyContent: 'left'
    },
    items: siteNavItems
  }), /*#__PURE__*/_react.default.createElement(_SiteToolbar.default, {
    disableGutters: true,
    className: _HeaderModule.default['bottom-nav-items'],
    sx: {
      mr: NAV_ITEM_OFFSET,
      justifyContent: 'right'
    },
    items: completeMemberNavItems
  })), /*#__PURE__*/_react.default.createElement(_material.Hidden, {
    mdUp: true
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _HeaderModule.default.menu
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    size: "large",
    color: "inherit",
    startIcon: /*#__PURE__*/_react.default.createElement(_iconsMaterial.Menu, null),
    onClick: toggleDrawer(true)
  }, "Menu"))))), /*#__PURE__*/_react.default.createElement(_material.Drawer, {
    anchor: "right",
    open: openMenu,
    onClose: toggleDrawer(false),
    PaperProps: {
      sx: {
        maxWidth: '80vw'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.List, null, _lodash.default.map([completeMemberNavItems, siteNavItems, relatedNavItems], (sectionItems, index) => /*#__PURE__*/_react.default.createElement(_HeaderListItems.default, {
    key: "header-item-".concat(index),
    items: sectionItems,
    index: index,
    onClick: toggleDrawer(false)
  })))));
};
Header.defaultProps = {
  relatedNavItems: [],
  siteNavItems: [],
  memberNavItems: [],
  subtitle: undefined
};
var _default = exports.default = Header;